import { useHierarchyArea } from '@plarium/hierarchy-react';

export const ConditionField = ({
  children,
  name,
  depends,
  when,
  keepValue,
}) => {
  const normalizeValue = (value, exist) =>
    exist || keepValue ? value : undefined;

  const { data: exist } = useHierarchyArea({
    name,
    source: when,
    depends,
    normalizeValue,
  });

  return exist ? children : null;
};
